import { Modal, Form, Button } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import DatePiker from "../../datepiker/datePiker";
import useAxios from "../../../services/useAxios";
import AuthenticationContext from "../../../Authentication/AuthenticationContext.ts";
import { CustomInput, ReactSelect } from "../../kits/Inputs/Inputs";

import {
  showSwalQuestion,
  showSwalSuccess,
  showSwalError,
} from "../../../utils/swal";
import Select from "react-select";

export default function FinancialReport({ show, setShow }) {
  const { userInfo } = useContext(AuthenticationContext);
  const [value, setValue] = useState("");
  const [value2, setValue2] = useState("");

  useEffect(() => {
    setValue("");
    setValue2("");
  }, []);
  const handleClose = () => setShow(false);
  const { execute: addLeadStep } = useAxios("api/");
  const add = () => {};
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>گزارش مالی</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label> از تاریخ: </Form.Label>
            <DatePiker
              setValue={setValue2}
              value={value2}
              type_calender={"persian"}
              location={"right"}
              color={"blue"}
              // bg={"bg-dark"}
              buttons={true}
              time={false}
              just_time={false}
              onlyYear={false}
              onlyMonth={false}
              hideWeekDays={true}
              hideMonth={false}
              highlightDay={true}
              color_highlight={"red"}
              // disableDay={true}
              weekend={"dis"}
              disableMonthPicker={false}
              disableYearPicker={false}
              plugins={true}
              // mood={"multi"}
              inputSize={"md"}
            ></DatePiker>
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label> تا تاریخ: </Form.Label>
            <DatePiker
              setValue={setValue}
              value={value}
              type_calender={"persian"}
              location={"right"}
              color={"blue"}
              // bg={"bg-dark"}
              buttons={true}
              time={false}
              just_time={false}
              onlyYear={false}
              onlyMonth={false}
              hideWeekDays={true}
              hideMonth={false}
              highlightDay={true}
              color_highlight={"red"}
              // disableDay={true}
              weekend={"dis"}
              disableMonthPicker={false}
              disableYearPicker={false}
              plugins={true}
              // mood={"multi"}
              inputSize={"md"}
            ></DatePiker>
          </Form.Group>
          <div className="mt-2">
            <Form.Check
              type={"radio"}
              name="group1"
              id={`default-radio`}
              label={`همه`}
            />
            <Form.Check
              type={"radio"}
              name="group1"
              id={`default-radio2`}
              label={`تراکنش`}
            />
            <Form.Check
              type={"radio"}
              name="group1"
              id={`default-radio3`}
              label={`سفارشات`}
            />
            <Form.Check
              type={"radio"}
              name="group1"
              id={`default-radio4`}
              label={`مانده حساب`}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            لغو
          </Button>
          <Button variant="primary" onClick={() => {}}>
            ارسال
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
